<template>
    <div class="pb-5" id="gift_detail_page">

        <div class="img-campaign-wrapper">
            <div class="icon-back" >
                <img @click="clickBack()" src="@/assets/icon/ic-back@3x.png"/>
            </div>
        </div>

        <div class="campaign-wrapper" v-if="campaign != null">

            <campaign-picture class="camp-pic" :arrCampaignImage="campaign.pictures"></campaign-picture>
            <h4 class="campaign-name">{{ campaign.name }}</h4>

            <!-- <div class="campaign-point">{{getPointMessage()}}</div> -->

            <FreeGiftDetailAndCondition
                :lbl="lbl"
                :campaign="campaign">
            </FreeGiftDetailAndCondition>

            <FreeGiftRedeem
                :lbl="lbl"
                :campaign="campaign"
                :selectedId="campaignId"
                :selectedPoint="point"
                :selectedQuantity="quantity"
                :tracking="tracking"
                @updateCampaignInfo="updateCampaignInfo($event)"
            ></FreeGiftRedeem>
        </div>

        <modal view="register-main" :busModal="busModal"></modal>
    </div>

</template>
<script>

import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper";
//component
import FreeGiftRedeem from "./component/RedeemGift/FreeGiftRedeem.vue";
import CampaignPicture from "./component/Picture.vue";
import FreeGiftDetailAndCondition from "./component/FreeGiftDetailAndCondition.vue";
import {
    CampaignConfigBuilder
} from "@/service/config/CampaignConfigModel.js";

import Modal from "@/components/modal/Modal.vue";

import Util from '@/helper/Utility.js';

export default {
    name: "Campaign",
    components: {
        FreeGiftRedeem,
        CampaignPicture,
        FreeGiftDetailAndCondition,
        Modal,
    },
    data: function() {
        return {
            isLogin: false,
            user: {},
            profile: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            campaignId: '',
            campaign: null,
            campaignConfig: null,

            point: 0,
            quantity: 0,
            busModal: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile();
        });

    },
    mounted: function () {

        this.initialConfig();
        this.getCampaign();

    },
    methods: {
        initialConfig: function () {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        getCampaign: function() {
            this.showLoading();
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).then((result) => {
                this.campaign = result;
                this.isLoaded = true;
                this.initialLayout();
                this.hideLoading();
            }).catch((error) => {
                this.hideLoading();
                 if (error.response) {
                     console.log(error);
                } else {
                    console.log(error);
                    this.showErrorConnectModal();
                    // this.isInternetConnected = false;
                }
            });
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
        },
        switchLang: function(locale) {
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        initialLayout: function () {

            if(this.campaign.subCampaignStyles2) {
                this.isShowSubcampaign = true;
                this.subCampaign = this.campaign.subCampaignStyles2.styles;

                if (this.campaign.subCampaignStyles2.styles.length > 0) {

                    var firstsubcampaign = this.campaign.subCampaignStyles2.styles[0];
                    if(firstsubcampaign.subitems[0].value != 'none') firstsubcampaign = firstsubcampaign.subitems[0];
                }

                this.updateSelectedCampaignInfo(firstsubcampaign);
            } else {
                this.updateSelectedCampaignInfo();
            }
        },
        getPointText: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var point = this.locale === 1033 && this.point != 1
                        ? this.lbl.detail.point + 's'
                        : this.lbl.detail.point;
            // var point =  this.lbl.detail.point;
            return pointTypeTxt + this.point + ' ' + point;
        },
        updateCampaignInfo: function () {
            console.log("getCampaign")
            this.getCampaign()
            // this.campaign.updateCampaign(campaign);
            // this.initialLayout();
        },
        updateSelectedCampaignInfo: function (selectedItem) {
            if(selectedItem) {
                this.campaignId  = selectedItem.campaignId;
                this.quantity = selectedItem.quantity - (selectedItem.itemCountSold || 0);
                this.point = selectedItem.points || selectedItem.point || 0;
                this.price = selectedItem.price;
                this.originalPrice = selectedItem.originalPrice;
                this.discount = selectedItem.discount;
            } else {
                this.campaignId = this.campaign.id;
                this.quantity = this.campaign.qty;
                this.point = this.campaign.pointPerUnit;
                this.price = this.campaign.pricePerUnit;
                this.originalPrice = this.campaign.originalPrice;
                this.discount = this.campaign.discount;
            }
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
        showErrorConnectModal: function() {

            var configModal = {

                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },

        clickBack: function () {
            this.$router.back();
        },
        getPointMessage: function () {
            console.log("getPointMessage");
            //var pointType = this.campaign.pointType == 'get' ? this.lbl.detail.get_point : this.lbl.detail.use_point;
            // var pointUnit = this.lblCampaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            var pointUnit = this.lbl.detail.point + (this.campaign.pointPerUnit != 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return Util.formatNum(this.campaign.pointPerUnit) + " " + pointUnit;
        },

    },
}
</script>
<style lang="scss">
    @import "./FreeGiftDetail.scss";
</style>

